import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Password berhasil diganti");
      setOldPw(""); setNewPw("");
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle>Ganti Password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label>Password lama</Label><Input type="password" value={oldPw} onChange={(e) => setOldPw(e.target.value)} data-testid="old-password-input" /></div>
          <div><Label>Password baru (min. 6)</Label><Input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} data-testid="new-password-input" /></div>
          <DialogFooter><Button type="submit" data-testid="change-password-submit">Simpan</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
